import { useEffect, useRef } from 'react';

/**
 * run onScan(barcode) after scanner done typing and send suffixKey.
 */
function useBarcodeScanner(
  onScan: (code: string) => void,
  { suffixKey = 'Enter', gap = 50, minLength = 3 } = {},
) {
  const buffer = useRef('');
  const lastKeyTime = useRef(0);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const now = Date.now();

      // if pause between char more then gap
      if (now - lastKeyTime.current > gap) buffer.current = '';

      lastKeyTime.current = now;

      if (e.key === suffixKey) {
        if (buffer.current.length >= minLength) onScan(buffer.current);
        buffer.current = '';
        return;
      }

      if (e.key.length === 1) buffer.current += e.key;
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onScan, suffixKey, gap, minLength]);
}

export default useBarcodeScanner;
